/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Status_SyncingInputs */

const en_offline_sync_status_syncing = /** @type {(inputs: Offline_Sync_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applying automatic sync...`)
};

const fr_offline_sync_status_syncing = /** @type {(inputs: Offline_Sync_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application de la synchronisation automatique...`)
};

const de_offline_sync_status_syncing = /** @type {(inputs: Offline_Sync_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Synchronisierung wird angewendet...`)
};

const it_offline_sync_status_syncing = /** @type {(inputs: Offline_Sync_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applicazione sincronizzazione automatica...`)
};

const ru_offline_sync_status_syncing = /** @type {(inputs: Offline_Sync_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Применение автоматической синхронизации...`)
};

const es_offline_sync_status_syncing = /** @type {(inputs: Offline_Sync_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicando sincronización automática...`)
};

const zh_cn2_offline_sync_status_syncing = /** @type {(inputs: Offline_Sync_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在应用自动同步...`)
};

const ja_offline_sync_status_syncing = /** @type {(inputs: Offline_Sync_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動同期を適用しています...`)
};

const hi_offline_sync_status_syncing = /** @type {(inputs: Offline_Sync_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित सिंक लागू किया जा रहा है...`)
};

const pt_pt2_offline_sync_status_syncing = /** @type {(inputs: Offline_Sync_Status_SyncingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A aplicar sincronização automática...`)
};

/**
* | output |
* | --- |
* | "Applying automatic sync..." |
*
* @param {Offline_Sync_Status_SyncingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_status_syncing = /** @type {((inputs?: Offline_Sync_Status_SyncingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Status_SyncingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_sync_status_syncing(inputs)
	if (locale === "de") return de_offline_sync_status_syncing(inputs)
	if (locale === "it") return it_offline_sync_status_syncing(inputs)
	if (locale === "ru") return ru_offline_sync_status_syncing(inputs)
	if (locale === "es") return es_offline_sync_status_syncing(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_sync_status_syncing(inputs)
	if (locale === "ja") return ja_offline_sync_status_syncing(inputs)
	if (locale === "hi") return hi_offline_sync_status_syncing(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_sync_status_syncing(inputs)
	return en_offline_sync_status_syncing(inputs)
});